// assistedWorkoutSteps/step3.js
import React from 'react';
import { Target, Dumbbell, Trophy } from 'lucide-react';

const StepThree = ({ formData, updateFields }) => {
  const experienceLevels = [
    {
      label: 'Beginner',
      icon: <Target size={32} />,
      description: 'New to fitness'
    },
    {
      label: 'Intermediate',
      icon: <Dumbbell size={32} />,
      description: '1-3 years experience'
    },
    {
      label: 'Advanced',
      icon: <Trophy size={32} />,
      description: '3+ years experience'
    }
  ];

  return (
    <div className="space-y-8 w-full">
      {/* Experience Level Section */}
      <div className="space-y-4">
        <label className="block text-lg aw-label">Fitness Experience</label>
        <div className="grid grid-cols-1 gap-3">
          {experienceLevels.map(({ label, icon, description }) => {
            const selected = formData.experienceLevel === label;
            return (
              <button
                type="button"
                key={label}
                onClick={() => updateFields({ experienceLevel: label })}
                className={`aw-card-option flex items-center text-left
                  ${selected ? 'aw-card-option-selected' : ''}`}
              >
                <div className={`mr-4 ${selected ? 'text-white' : 'text-red-600'}`}>{icon}</div>
                <div>
                  <span className="block font-bold">{label}</span>
                  <span className={`text-sm ${selected ? 'text-white/80' : 'text-gray-500'}`}>
                    {description}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Physical Limitations Section */}
      <div className="space-y-3">
        <label className="block text-lg aw-label">
          Physical Limitations or Injuries
        </label>
        <p className="text-sm text-gray-500">
          Please describe any injuries or physical limitations we should consider when creating your workout plan.
          Leave blank if none.
        </p>
        <textarea
          value={formData.limitations || ''}
          onChange={(e) => updateFields({ limitations: e.target.value })}
          placeholder="Example: Recent knee surgery, Lower back pain, etc."
          className="aw-input h-32 resize-none"
        />
      </div>
    </div>
  );
};

export default StepThree;